// extracted by mini-css-extract-plugin
export default {"page":"Login_page__c7J9f","main":"Login_main__Mb6nk"};